import { useEffect, useState } from 'react';
import { supabase } from '../../utils/supabaseClient';
import { buildGearCatalog } from '../../domain/gearCatalog';

let cached = null;
let pending = null;
const CACHE_MS = 60 * 1000;
async function readAll(table, columns, active = false) {
  const rows = [];
  for (let start = 0; ; start += 1000) {
    let query = supabase.from(table).select(columns).order(table === 'products' ? 'id' : 'product_offer_id').range(start, start + 999);
    if (active) query = query.eq('is_active', true);
    const { data, error } = await query;
    if (error) throw new Error('Retailer prices could not be loaded.');
    rows.push(...(data || []));
    if ((data || []).length < 1000) return rows;
  }
}
async function loadCatalog() {
  if (!supabase) throw new Error('Retailer prices are temporarily unavailable.');
  if (cached && Date.now()-cached.at < CACHE_MS) return cached;
  if (!pending) pending = Promise.all([
    readAll('products', 'id,slug,name,brand,category,image_url,is_active,msrp,manufacturer_info', true),
    readAll('latest_prices_view', 'product_offer_id,product_id,website,current_price,list_price,variant_label,affiliate_url,last_success_at,last_checked_at,availability_status'),
  ]).then(([products,offers]) => { cached={ products, offers, at:Date.now() }; return cached; }).finally(() => { pending=null; });
  return pending;
}
export default function useGearCatalog() {
  const [state,setState] = useState({ products: [], offers: [], loading:true, error:null });
  const [attempt,setAttempt] = useState(0);
  const [now,setNow] = useState(Date.now());
  useEffect(() => {
    let cancelled=false;
    setState(s=>({...s,loading:true,error:null}));
    loadCatalog().then(data=>{if(!cancelled)setState({...data,loading:false,error:null});}).catch(error=>{if(!cancelled)setState(s=>({...s,loading:false,error:error.message}));});
    return()=>{cancelled=true;};
  },[attempt]);
  useEffect(()=>{const timer=setInterval(()=>setNow(Date.now()),60000);return()=>clearInterval(timer);},[]);
  return { products:buildGearCatalog(state.products,state.offers,now), loading:state.loading, error:state.error,
    retry:()=>{cached=null;setAttempt(n=>n+1);} };
}
